import React, { useState } from 'react';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        console.log('Menu toggled:', !isOpen); // Debugging line
        setIsOpen(!isOpen);
    };

    return (
        <nav className="w-full px-5 sm:px-10 py-5 shadow-xl backdrop-blur-lg fixed top-0 z-10 bg-orange-200">
            <div className="container flex justify-between items-center max-w-5xl mx-auto p-1">
                <h3 className="text-3xl text-white bg-orange-400 font-bold py-1 px-1">
                    Mela-Software
                </h3>
                <div className="lg:hidden">
                    <button 
                        onClick={toggleMenu} 
                        className="text-black focus:outline-none"
                        aria-label={isOpen ? "Close menu" : "Open menu"}
                    >
                        <svg 
                            className="w-6 h-6" 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth="2" 
                                d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"} 
                            />
                        </svg>
                    </button>
                </div>
                <ul className={`flex-col lg:flex-row gap-2 align-center p-1 flex-wrap lg:flex ${isOpen ? 'flex' : 'hidden'} lg:flex`}>
                    <li>
                        <a className="text-sm sm:text-base px-2 lg:px-4 py-1 transition rounded hover:text-white hover:bg-orange-400" href="#about">
                            About
                        </a>
                    </li>
                    <li>
                        <a className="text-sm sm:text-base px-2 lg:px-4 py-1 transition rounded hover:text-white hover:bg-orange-400" href="#services">
                            Services
                        </a>
                    </li>
                    <li>
                        <a className="text-sm sm:text-base px-2 lg:px-4 py-1 transition rounded hover:text-white hover:bg-orange-400" href="#achievements">
                            Achievements
                        </a>
                    </li>
                    <li>
                        <a className="text-sm sm:text-base px-2 lg:px-4 py-1 transition rounded hover:text-white hover:bg-orange-400" href="#contact">
                            Contact
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}